import { render, staticRenderFns } from "./SiteGroupReport.vue?vue&type=template&id=b0fd8fd8"
import script from "./SiteGroupReport.vue?vue&type=script&lang=js"
export * from "./SiteGroupReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports